import { NavLink } from 'react-router-dom';
import { ClipboardText, PlusCircle } from 'shared/icons';
import { useAuth } from '../../hooks/useAuth';

const WmsNavigation = () => {
    const { checkPermission } = useAuth();

    const links = [
        { to: '/wms', label: 'Dashboard', icon: ClipboardText, permission: 'wms:read', end: true },
        {
            to: '/wms/create',
            label: 'Novo Outbound',
            icon: PlusCircle,
            permission: 'wms:outbound:create',
        },
    ].filter((link) => !link.permission || checkPermission(link.permission));

    const getLinkClass = ({ isActive }) =>
        `py-3 px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap flex items-center gap-1.5 sm:gap-2 ${
            isActive
                ? 'border-black dark:border-white text-black dark:text-white'
                : 'border-transparent text-mono-500 hover:text-mono-700 dark:hover:text-mono-300 hover:border-mono-300'
        }`;

    return (
        <div className="border-b border-mono-200 dark:border-mono-800 mb-6">
            <nav className="flex gap-5 sm:gap-8 overflow-x-auto pb-1">
                {links.map((link) => {
                    const Icon = link.icon;
                    return (
                        <NavLink key={link.to} to={link.to} end={Boolean(link.end)} className={getLinkClass}>
                            <Icon size={18} />
                            {link.label}
                        </NavLink>
                    );
                })}
            </nav>
        </div>
    );
};

export default WmsNavigation;
